/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Link } from 'react-router-dom';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import userPlaceholder from 'assets/img/icon-user.svg';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import _ from 'lodash';
import Logo from 'assets/img/logo-white.png';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import * as authActions from 'modules/auth/actions';
// import * as c from 'modules/auth/constants';

import CmsContext from '../../../context/CmsContext';

const demoData = JSON.parse(sessionStorage.getItem('demoData'));

function Header({ logout, profile, history }) {
  const [toggle, setToggle] = useState(false);

  const cmsContext = useContext(CmsContext);
  const CMS_COLORS = cmsContext.findByType('COLORS');

  const handleOnDrop = (value) => (e) => {
    e.preventDefault();
    setToggle(value);
  };

  const handleClickBody = (e) => {
    try {
      if (e.target.className.indexOf('for-dropdown-navigation') < 0) {
        setToggle(false);
      }
    } catch (error) {
      // do nothing
    }
  };

  const handleOnLogOut = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to logout?',
      () => {
        logout(() => {
          history.push('/');
        });
      },
      () => {},
      {
        yesLabel: 'Log out',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    document.body.addEventListener('click', handleClickBody);
    return () => {
      document.body.removeEventListener('click', handleClickBody);
    };
  }, []);

  const expandIcon = toggle ? <ExpandLessIcon className="sidebar-item-expand-arrow sidebar-item-expand-arrow-expanded cms-text-primary" /> : <ExpandMoreIcon className="sidebar-item-expand-arrow" />

  const photo = _.get(profile, 'photo', '');
  const first_name = _.get(profile, 'first_name', '');
  const last_name = _.get(profile, 'last_name', '');
  
  return (
    <header className="main-header sticky-top" style={{borderBottom: `3px solid ${_.get(CMS_COLORS, "primary_color") || '#fff'}`}}>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-3">
        <div className="container-fluid">
          <div className="ml-auto">
            <ul className="navbar-nav">
              <li className="nav-item dropdown for-dropdown-navigation">
                <button
                  type="button"
                  className="btn btn-link user-dropdown nav-link dropdown-toggle btn-blank"
                  onClick={handleOnDrop(!toggle)}
                >
                  <div className="user-photo small">
                    {!_.isEmpty(photo) ? (
                      <img
                        className="thumbnail"
                        src={`${photo}`}
                        alt={`${first_name} ${last_name}`}
                      />
                    ) : (
                      <img
                        className="thumbnail"
                        src={userPlaceholder}
                        alt={`${first_name} ${last_name}`}
                      />
                    )}
                  </div>
                  <div className="info">
                    <h3 className="name header-name cms-text-primary">
                      Hi! {`${first_name} ${last_name}`}{' '}{expandIcon}
                    </h3>
                  </div>
                </button>
                <div className={`dropdown-profile ${toggle ? 'show' : ''} dropdown-menu`}>
                  <Link to="/profile" className="dropdown-item">
                    Profile
                  </Link>
                  <button
                    type="button"
                    className="dropdown-item"
                    onClick={handleOnLogOut}
                  >
                    Log Out
                  </button>
                </div>
              </li>
              <li className="nav-item notification" />
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

Header.propTypes = {
  logout: PropTypes.instanceOf(Function).isRequired,
  profile: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({
  profile: getJson('profile'),
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, authActions),
]);

export default enhance(Header);
